import BaseClient from '@/app/model/api/response/baseApiClient'

class AreaListApi extends BaseClient {
  public getAreaList (data: any) {
    const path = '/v1/master/areas'
    const url = new URL(process.env.VUE_APP_API_URL + path)
    const params = new URLSearchParams({})

    if (data !== '') {
      if (data.text !== '') {
        params.append('word', data.text)
      }

      if (data.sortName !== 0) {
        params.append('order_name', data.sortName)
        params.append('sort', data.sort)
      }
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new AreaListApi()
